import * as React from 'react';

import { useListActionButtons } from './useListActionButtons';
import { ListActionButtons } from '../../components/ListActionButtons';

export const ListActionButtonsContainer: React.VFC = () => {
  const {
    isChangeListActive,
    isReadButtonDisabled,
    onArchiveClick,
    onDeleteClick,
    onReadClick,
    onRestoreClick,
    isMultiple,
    isPending,
    isArchive,
  } = useListActionButtons();

  if (!isChangeListActive) {
    return null;
  }

  return (
    <ListActionButtons
      isReadButtonDisabled={isReadButtonDisabled}
      isArchive={isArchive}
      onArchiveClick={onArchiveClick}
      onDeleteClick={onDeleteClick}
      onReadClick={onReadClick}
      onRestoreClick={onRestoreClick}
      isMultiple={isMultiple}
      isPending={isPending}
    />
  );
};
